import React, { useEffect } from "react";
import useBlogCalls from "../service/useBlogCalls";
import { useSelector } from "react-redux";
import { Button, Grid } from "@mui/material";
import BlogCard from "../components/blog/BlogCard";
import { useNavigate } from "react-router-dom";
import { teal, red } from "@mui/material/colors";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";

const MyBlogs = () => {
  const {  getMyBlog, getGeneralData } = useBlogCalls();
  const { token, userId, user,email } = useSelector((state) => state.auth);
  console.log("🚀 ~ MyBlogs ~ email:", email)
  console.log("🚀 ~ MyBlogs ~ token:", token);
  const { blogs, myBlog,very } = useSelector((state) => state.blog);
  console.log("🚀 ~ MyBlogs ~ very:", very)

  
  const primary = teal[50]; // #f44336
  const accent = teal[300];

  const navigate = useNavigate();

  const myBlogs = very.filter((blog) => blog.userId == userId);
 

  useEffect(() => {
    getGeneralData();
  }, []);
  useEffect(() => {
    getMyBlog(userId);
  }, []);

  return myBlogs && myBlogs.length > 0 ? (
    <div className="myBlog">
      <Helmet>
        <title>MyBlog | Blogia</title>
        <meta name="description" content="myBlog description" />
      </Helmet>
      <div style={{ textAlign: "center" }}>
        <h1
          style={{
            textAlign: "center",
            fontSize: "2rem",
            padding: "1rem",
            backgroundColor: "RGBA(43,45,66,0.8)",
            display: "inline-block",
            color: "white",
            borderRadius: "20px",
          }}
        >
          {user}'s Blogs
        </h1>
      </div>
      <Grid
        container
        pt={3}
        pl={3}
        spacing={2}
        justifyContent="center"
        alignItems="Flex-start"
      >
        <Grid
          item
          xs={12}
          lg={6}
          mt={4.5}
          container
          alignItems="center"
          justifyContent="center"
        >
          {myBlog?.map((item, i) => (
            <Grid item xs={12} md={6} key={i}>
              <BlogCard item={item} userId={userId} />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </div>
  ) : (
    <div className="noBlog">
      <h1
        style={{
          textAlign: "center",
          fontWeight: "bold",
          color: "#000238",
          fontSize: "5rem",
        }}
      >
        My BLOG's
      </h1>
      <div style={{ textAlign: "center" }}>
        <h1
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            margin: "auto",
            textAlign: "center",
            color: "white",
            padding: "2rem 1rem",
            borderRadius: "20px",
            fontSize: "1.3rem",
            display: "inline-block",
            marginBottom: "1rem",
          }}
        >
          You haven't made any blog entries yet.
        </h1>
        <br />
        <Button
          sx={{ color: primary, backgroundColor: accent }}
          variant="contained"
          onClick={() => navigate("/newBlog")}
        >
          {" "}
          Make A Post
        </Button>
      </div>
    </div>
  );
};

export default MyBlogs;
